module.exports = __webpack_public_path__ + "img/Industrial Strength.ed6aaab7.jpg";